module.exports = __webpack_public_path__ + "static/media/plus.f1ff65cd.svg";